import { useState, useEffect } from "react";
import { Tabs } from "antd";
import styled from "styled-components"
import GroupTab from "./GroupTab/GroupTab";
import DictionaryTab from "./DictionaryTab/DictionaryTab";
import axios from "axios";

const backend = process.env.REACT_APP_BACKEND
const StyledTabs = styled((props)=> <Tabs {...props} />)`
  .ant-tabs-content {
    display: flex;
    height: 100%;
  }
  .ant-tabs-content > .ant-tabs-tabpane {
    width: 100%;
  }
  .ant-tabs-tabpane > div > div > div {
    display: flex;
    flex-direction: column;
  }
`

function WordDictionary () {
  const [languageGroup, setLanguageGroup] = useState([])
  // const [baseParams, setBaseParams] = useState({
  //   pos: "all",
  //   cefrLevelByEVP: "all",
  //   cefrLevelByGPT: "all",
  //   language: "all"
  // })

  // const basePramsHandler = (newBasePrams) => {
  //   setBaseParams(newBasePrams)
  // }

  const items = [
    {
      key: "1",
      label: "그룹",
      children: <GroupTab languageGroup={languageGroup}/>
    },
    {
      key: "2",
      label: "단어장",
      children: <DictionaryTab languageGroup={languageGroup}/>
    },
  ]

  useEffect(()=>{
    axios.get(`${backend}/contents/word_dictionary`)
    .then(res=>{
      setLanguageGroup(res.data.data)
    })
    .catch(err=>{
      console.log(err)
    })
  },[])

  return (
    <div style={{height:"100%", width:"100%", display:"flex"}}>
      <StyledTabs
        defaultActiveKey="1"
        destroyInactiveTabPane={true}
        items={items}
        type="card"
        size="small"
        style={{width:"100%"}}
      >

      </StyledTabs>
    </div>
  )
}

export default WordDictionary